@if (loading()) {
<loading [stroke]="'white'"
         [scale]="0.8"
         [size]="spinnerSize()"
         [strokeWidth]="spinnerStrokeWidth()"></loading>
} @else {
<ng-content></ng-content>
}